import { IoCContainer, ISidebarModule } from '@lmnop/web-core';
import { AppIoCKeys, IAppIoCContainer } from '../public';

export class ClearLocalStorageModule implements ISidebarModule {
    public static SIDEBAR_BUTTON_CLASS: string = 'wecdev-bar-button';
    public isDrawn = false;
    public name = 'Clear Local Storage Module';

    private get ioc(): IAppIoCContainer {
        return IoCContainer.get(AppIoCKeys.IAppIoCContainer);
    }

    public drawModule(container: HTMLElement): void {
        if (this.isDrawn) return;

        let button: HTMLButtonElement = document.createElement('button');
        button.className = ClearLocalStorageModule.SIDEBAR_BUTTON_CLASS;
        button.innerHTML = 'Clear LocalStorage';

        button.addEventListener('click', (e: Event): boolean => {
            this.clearLocaStorage();
            return false;
        });
        container.appendChild(button);

        this.isDrawn = true;
    }

    private clearLocaStorage() {
        localStorage.clear();
        location.reload();
    }
}
